import React from 'react';
import {View, StyleSheet, Text, Pressable} from 'react-native';
import CustomRadioButton from 'src/components/elements/CustomRadioButton';
import Styles from 'src/components/Styles';
import {getDescriber} from './descriptor/DescriptorType';
import {LocationType} from 'src/types/Location';

const {
  pickupLocationListStyles,
  pickupLocationInnerCircleBackgroundColor,
  pickupLocationOuterCircleBorderColor,
} = getDescriber();

type MobileOrderLocationListProps = {
  item: LocationType;
  index?: number;
  selectMobileOrderLocation?: (item) => void;
  selectedValue?: boolean;
};
const PickupMobileOrderLocationList = (props: MobileOrderLocationListProps) => {
  const {item, selectMobileOrderLocation, selectedValue} = props;
  const onPressLocation = (locationItem) => {
    selectMobileOrderLocation(locationItem);
    return;
  };

  return (
    <Pressable
      key={item.locationId + '-' + Date.now()}
      style={
        selectedValue
          ? pickupLocationListStyles().cellSelected
          : pickupLocationListStyles().cell
      }
      onPress={() => onPressLocation(item)}
      accessible={true}
      accessibilityRole="button"
      role="button"
      nativeID={'Btn' + item.displayName}
    >
      <View
        accessibilityLabel={item.displayName + ', '}
        style={styles.leftView}
      >
        <CustomRadioButton
          selected={selectedValue}
          accessibilityLabel={item.displayName}
          aria-label={item.displayName}
          onPress={() => onPressLocation(item)}
          touchableAreaPaddingStyle={styles.touchableAreaPaddingStyle}
          outerCircleStyle={{
            ...styles.outerCircleStyle,
            ...(selectedValue && {
              borderColor: pickupLocationOuterCircleBorderColor(),
            }),
          }}
          innerCircleStyle={styles.innerCircleStyle}
        />
        <Text
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
          accessibilityRole="text"
          aria-label={item.displayName}
          nativeID={item.displayName}
          style={
            selectedValue
              ? pickupLocationListStyles().selectedLabel
              : pickupLocationListStyles().label
          }
          accessibilityLabel={item.displayName}
        >
          {item.displayName}
        </Text>
      </View>
    </Pressable>
  );
};
export default PickupMobileOrderLocationList;
const styles = StyleSheet.create({
  touchableAreaPaddingStyle: {
    padding: 0,
  },
  outerCircleStyle: {
    height: 29,
    width: 29,
    borderRadius: Styles.Heights.h5,
    borderWidth: 2,
    overflow: 'hidden',
  },
  innerCircleStyle: {
    height: 19,
    width: 19,
    borderRadius: Styles.Heights.h5,
    backgroundColor: pickupLocationInnerCircleBackgroundColor(),
    overflow: 'hidden',
  },
  leftView: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  rightView: {
    paddingLeft: Styles.Heights.h2 + 4,
    alignItems: 'center',
    flexDirection: 'row',
  },
});
